import { Typography } from "@material-ui/core"

export const UVIDTestView = ({ procedureData }: { procedureData: any }) => {
    return (
        <div>
            <Typography variant="body1">
                UVAB irradiance : {procedureData?.uvid_test?.uvab_irradiance ? `${procedureData.uvid_test.uvab_irradiance} W/m²` : "N/A"}
            </Typography>
            <Typography variant="body1">
                UVAB totaldose : {procedureData?.uvid_test?.uvab_totaldose ? `${procedureData.uvid_test.uvab_totaldose} kWh/m² ` : "N/A"}
            </Typography>
            <Typography variant="body1">
                UVAB irradiance ratio : {procedureData?.uvid_test?.uvab_irradiance_ratio ? `${procedureData.uvid_test.uvab_irradiance_ratio}%` : "N/A"}
            </Typography>
            <Typography variant="body1">
                {/* Type of lightsource : {procedureData?.uvid_test?.type_of_lightsource ? `${procedureData.uvid_test.type_of_lightsource}°C` : "N/A"}  */}
            </Typography>

            <Typography variant="body1">
                Dut operating condition: {procedureData?.uvid_test?.dut_operatingcondition ? procedureData.uvid_test.dut_operatingcondition : "N/A"}
            </Typography>

            {(procedureData?.tst_version === "v12" &&
                <>
                    <Typography variant="body1">
                        Dut exposed surface :  {procedureData?.uvid_test?.dut_exposedsurface ? procedureData.uvid_test.dut_exposedsurface : "N/A"}
                    </Typography>
                </>
            )}


            <Typography variant="body1">
                Set Temperature: {procedureData?.uvid_test?.set_temperature ? `${procedureData.uvid_test.set_temperature} °C` : "N/A"}
            </Typography>
            <Typography variant="body1">
                Temperature Controlmode: {procedureData?.uvid_test?.temperature_controlmode ? procedureData.uvid_test.temperature_controlmode : "N/A"}
            </Typography>
            <Typography variant="body1">
                Equipment Calibration date: {procedureData?.uvid_test?.equipment_calibration_date ? procedureData.uvid_test.equipment_calibration_date.substring(0, 10) : "N/A"}
            </Typography>
            <Typography variant="body1">
                Dut average temperature: {procedureData?.uvid_test?.dut_averagetemperature ? `${procedureData.uvid_test.dut_averagetemperature} °C` : "N/A"}
            </Typography>

        </div>
    )
}